<template>
  <div class="step-block">
    <SmartDivideStatusListDrawer
      v-if="showTask"
      ref="smartDivideStatusListDrawer"
      class="divide-status-block"
      :step="step"
      @getSuccess="successDivide"
    ></SmartDivideStatusListDrawer>
    <section class="step">
      <div class="left" :class="step == -1 ? 'active' : ''">
        <div class="icon-left"></div>
        <div class="icon-middle">1.选择学校</div>
        <div class="icon-right"></div>
      </div>
      <div class="left" :class="step == 1 ? 'active' : ''">
        <div class="icon-left"></div>
        <div class="icon-middle">2.分班确认</div>
        <div class="icon-right"></div>
      </div>
      <div class="left" :class="step == 2 ? 'active' : ''">
        <div class="icon-left"></div>
        <div class="icon-middle">3.确定成班</div>
        <div class="icon-right"></div>
      </div>
      <!-- <div class="left"></div> -->
      <div></div>
    </section>
  </div>
</template>
<script>
import SmartDivideStatusListDrawer from './SmartDivideStatusListDrawer';
export default {
  components: { SmartDivideStatusListDrawer },
  props: {
    step: {
      type: Number,
      default: -1
    },
    schoolId: {
      type: String,
      default: ''
    }, // 学校id
    termCode: {
      type: String,
      default: ''
    },
    yearCode: {
      type: Number,
      default: 0
    },
    // 学期id
    random: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  computed: {
    showTask() {
      return this.termCode && this.yearCode && this.schoolId;
    }
  },
  watch: {
    random() {
      if (this.showTask) {
        this.$nextTick(() => {
          this.$refs.smartDivideStatusListDrawer.initLoadingTag({
            termCode: this.termCode, yearCode: this.yearCode, schoolId: this.schoolId
          });
        });
      }
    }
  },
  methods: {
    successDivide() {
      console.log('step组件接收到分班成功的消息');
      this.$emit('divided');
    }
  }
};
</script>
<style lang="scss" scoped>
.step-block {
  padding: 16px 15% 0;
  position: relative;
  .divide-status-block {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}
.step {
  display: flex;
  .left {
    width: 50%;
    height: 40px;
    display: flex;

    // background: #488ffa;
    .icon-left {
      width: 0;
      height: 0;
      border-top: 20px solid rgb(247, 248, 250);
      border-left: 10px solid transparent;
      border-bottom: 20px solid rgb(247, 248, 250);
    }

    .icon-middle {
      width: 100%;
      background: rgb(247, 248, 250);
      color: black;
      font-weight: 600;
      text-align: center;
      line-height: 40px;
      // font-size: 20px;
    }

    .icon-right {
      width: 0;
      height: 0;
      border-top: 20px solid transparent;
      border-left: 10px solid rgb(247, 248, 250);
      border-bottom: 20px solid transparent;
    }
  }

  .left.active {
    .icon-left {
      width: 0;
      height: 0;
      border-top: 20px solid #488ffa;
      border-left: 10px solid transparent;
      border-bottom: 20px solid #488ffa;
    }

    .icon-middle {
      width: 100%;
      background: #488ffa;
      color: #fff;
      font-weight: 600;
      // font-size: 20px;
      text-align: center;
      line-height: 40px;
    }

    .icon-right {
      width: 0;
      height: 0;
      border-top: 20px solid transparent;
      border-left: 10px solid #488ffa;
      border-bottom: 20px solid transparent;
    }
  }
}
</style>
